<template>
    <div id="gl_account_configuration_create" class="fleet-form-main">
        <div class="loader" v-show="loading">
        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="groupHeader" v-if="$route.params.id > 0">Update GL Account Configuration</span>
                    <span class="page-title" id="groupHeader" v-else>Add GL Account Configuration</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackGLAccConfList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content group-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="GroupForm">
                                <div class="form-row">
                                    <div class="col-sm-4 form-group">
                                        <label class="control-label require" for="name">Module:</label>
                                        <input type="text" class="form-control" disabled v-model="module" id="module" placeholder="Enter Module" name="module">
                                        <div class="field-error">{{module_error_message}}</div>

                                    </div>
                                    <div class="col-sm-4 form-group">
                                      <label class="control-label require" for="name">Key:</label>
                                      <input type="text" class="form-control" disabled v-model="key" id="key" placeholder="Enter Key" name="key">
                                      <div class="field-error">{{key_error_message}}</div>
                                    </div>
                                    <div class="col-sm-4 form-group">
                                      <label class="control-label require" for="name">GL Code:</label>
                                      <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                      <div class="field-error">{{code_error_message}}</div>
                                    </div>
                                </div>
                                <div class="form-row">
                                    <div class="col-sm-6 form-group">
                                        <div class="custom-checkbox">
                                            <label class="checkbox-custom"> Location Required
                                                <input type="checkbox" v-model="location_required" id="location_required" name="location_required">
                                                <span class="checkmark"></span>
                                            </label>
                                        </div>
                                    </div>
                                    <div class="col-sm-3 form-group">
                                      <div class="custom-checkbox">
                                        <label class="checkbox-custom"> Pool Required
                                            <input type="checkbox" v-model="pool_required" id="pool_requried" name="pool_required">
                                            <span class="checkmark"></span>
                                        </label>
                                      </div>
                                    </div>
                                    <div v-show="pool_required" class="col-sm-3 form-group">
                                        <label class="control-label require">Product Line:</label>
                                        <v-select class="close-remove" v-model="productLine" name="productLine" data-info="Please select Product Line" placeholder="Please select Product Line."
                                            label="text"
                                            :options="productLineArr">
                                        </v-select>
                                        <div class="field-error">{{ productLineErrorMessage }}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createGroupBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateGroup" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createGroupBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateGroup" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueGroupBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateGroup(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelGroupBtn" class="btn btn-tertiary" v-on:click.prevent="BackGLAccConfList">
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins'

export default {
  name: "GLAccConfig",
  metaInfo() {
    let head;
    if(this.$route.params.id > 0){
        head = "Update GL Account Configuration | FleetPro Application";
    }else{
        head = "Add GL Account Configuration | FleetPro Application";
    }
      return {title: head}
  },
  mixins:[commonMixins],
  data: () => ({
     permissions: [],
    cantAccessPage: "",
    name: "",
    checkboxValue: "",
    checked: "",
    loading:false,
    name_error_msg: "",
    module: "",
    key: "",
    code: "",
    location_required: "",
    pool_required: "",
    code_error_message: "",
    module_error_message: "",
    key_error_message:"",
    productLineErrorMessage:"",
    productLine:"",
    productLineArr:[]
  }),
  created: function() {

  },
  watch: {

      //check permission change
      permissions: function (permissions) {
          var self = this;
          if (permissions.length > 0) {
              for (var i = 0; i < permissions.length; i++) {
                  if (permissions[i].name == 'add_group') {
                      self.cantAccessPage = true;                  }
              }
          }

      }

   },
  mounted: function() {
        var self = this;
        self.checkboxValue = 0;

        // var path = window.location.pathname;
        // var segments = path.split("/");

        // if (segments[3]) {
        //     $("#createGroupBtn").val("Update");
        //     $("#groupHeader").text("Edit Group");
        //     $("#createAndContinueGroupBtn").hide();
        //     self.loadGroup();

        // }
        self.getPermissions();
        setTimeout(function () {
                var path = window.location.pathname;
                var segments = path.split("/");

                if (segments[3]) {
                    self.loadGroup();
                }
            }, 100);
  },
  methods: {

    BackGLAccConfList(){
        var self = this;
        self.$router.push("/gl-account-configuration/list");
    },

    CreateGroup(flag) {
      var self = this;
      var error = false;
      self.module = self.module.trim();
      self.key = self.key.trim();
      self.code = self.code.trim();

      self.module_error_message = "";
      self.code_error_message = "";
      self.key_error_message = "";

      if (!self.module || self.module == null || self.module == "") {
        self.module_error_message = "Module Required.";
        error = true;
      } else{
        self.module_error_message = "";
      }

      if (!self.key || self.key == null || self.key == "") {
        self.key_error_message = "Key Required.";
        error = true;
      } else{
        self.key_error_message = "";
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_message = "Code Required.";
        error = true;
      } else{
        if (self.code.length != 4) {
          self.code_error_message = "Code Should be of length 4.";
          error = true;
        } else{
          self.code_error_message = "";
        }
      }


      if (!error) {

            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createGroupBtn").val("Updating ...");
                $("#createGroupBtn").prop("disabled", true);
                $("#cancelGroupBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueGroupBtn").val("Saving ...");
                    $("#createGroupBtn").prop("disabled", true);
                    $("#createAndContinueGroupBtn").prop("disabled", true);
                    $("#cancelGroupBtn").prop("disabled",true);

                }else{

                    $("#createGroupBtn").val("Saving ...");
                    $("#createGroupBtn").prop("disabled", true);
                    $("#createAndContinueGroupBtn").prop("disabled", true);
                    $("#cancelGroupBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/gl-account-configuration/create",
                type: "POST",
                data: {module: self.module,key: self.key,code: self.code,
                            location_required: self.location_required,
                            pool_required: self.pool_required,
                            id: segments[3],productLine: self.productLine},
                headers:this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createGroupBtn").val("Update");
                        $("#createGroupBtn").prop("disabled", false);
                        $("#cancelGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueGroupBtn").val("Save and Continue");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }else{

                            $("#createGroupBtn").val("Save");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#GroupForm").trigger("reset");
                            self.name ="";
                            self.checkboxValue = "";
                            self.checked = "";

                        }else{
                            self.$router.push("/gl-account-configuration/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                          var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }else{
                          $("#errorMsg").html(data.message);
                          $(".alert-warning").toggleClass("show");
                          setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                          }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createGroupBtn").val("Update");
                        $("#createGroupBtn").prop("disabled", false);
                        $("#cancelGroupBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#GroupForm").trigger("reset");


                            $("#createAndContinueGroupBtn").val("Save and Continue");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }else{

                            $("#createGroupBtn").val("Save");
                            $("#createGroupBtn").prop("disabled", false);
                            $("#createAndContinueGroupBtn").prop("disabled", false);
                            $("#cancelGroupBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'gl-account-configuration-create')
                }
            });
      }else{
            self.errorValidationFocus();
      }
    },

    loadGroup() {

        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/gl-account-configuration/" + segments[3],
            type: "GET",
            headers:this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {

                    self.key = data.content.glData.key;
                    self.module = data.content.glData.module;
                    self.code = data.content.glData.code;
                    if (data.content.glData.location_required == "1"){
                      self.location_required = true;
                    }else{
                      self.location_required = false;
                    }
                    if (data.content.glData.pool_required == "1"){
                      self.pool_required = true;
                    }else{
                      self.pool_required = false;
                    }
                    self.productLineArr = data.content.productLine;

                    if ( data.content.glData.pool_code == null ) {
                        self.productLine = "00";
                    } else {
                        self.productLine = data.content.glData.pool_code;
                    }
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'group-by-id-load')
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/GlAccountConfigurationCreate.vue